import React from 'react';

import { bemCssModules } from '@utils';

import MainLayout, { TMainLayout } from '@layouts/MainLayout';

import style from './LoginLayout.scss';

const cn = bemCssModules(style, 'LoginLayout');

export type TLoginLayout = {
  image?: React.ReactNode;
  isHideLinks?: boolean;
  backButton?: TMainLayout['backButton'];
};

export const LoginLayout: CustomFC<TLoginLayout> = props => {
  const { children, className, image, backButton = true, isHideLinks } = props;

  return (
    <MainLayout className={cn(null, [className])} backButton={backButton} isHideLinks={isHideLinks}>
      <div className={cn('wrapper')}>
        <div className={cn('content')}>{children}</div>
        <div className={cn('image')}>{image}</div>
      </div>
    </MainLayout>
  );
};

export default LoginLayout;
